import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";
import {
  clearKioskSession,
  hasKioskSession,
  waitForKioskAuthReady,
} from "@/kiosk/services/kioskAuth.service";

export default async (
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const requiresKioskAuth = to.matched.some((record) => record.meta.requiresKioskAuth);
  const redirectRecord = to.matched.find((record) => record.meta.redirectKioskAuth);

  if (!requiresKioskAuth && !redirectRecord) {
    next();
    return;
  }

  const tokenHash = typeof to.params.tokenHash === "string" ? to.params.tokenHash : "";

  await waitForKioskAuthReady();

  const hasSession = hasKioskSession(tokenHash);
  if (!hasSession) {
    await clearKioskSession();
  }

  if (hasSession && redirectRecord) {
    next({
      name: redirectRecord.meta.redirectKioskAuth as string,
      params: {
        ...to.params,
        tokenHash,
      },
    });
    return;
  }

  if (requiresKioskAuth && !hasSession) {
    next({
      name: "kioskPinLogin",
      params: {
        tokenHash,
      },
    });
    return;
  }

  next();
};
